import { formatINR } from "@creators/backend/lib/money";
import { OFFER_BOOST_TOTAL_PAISE } from "@creators/backend/lib/offer-boosts";

/** Shared FAQ copy for the marketing page, JSON-LD, and SEO prerender. */
export const FAQS = [
  {
    question: "Does Send Collab take a percentage of my payments?",
    answer:
      "No — not from an advance, a balance or a final tranche. Payments go straight from your collaborator to your UPI ID or bank account, so there is nothing for the platform to clip.",
  },
  {
    question: "Is there escrow to protect me?",
    answer:
      "No, and that is deliberate. Escrow means someone holds your money and then decides who wins an argument. Instead you get an advance before work starts, a schedule that ties each tranche to a milestone, a written record of what both sides claimed and when, and the other side's payment history before you agree to anything.",
  },
  {
    question: "What happens if the other side goes quiet?",
    answer:
      "The clock handles it. An unanswered offer expires instead of hanging over you. An accepted deal where the advance never arrives lapses before you have started work. A draft nobody reviews approves itself, and the next tranche falls due.",
  },
  {
    question: "Who can see my payment screenshots?",
    answer:
      "Only the two parties on that collab, and only once they have confirmed who they are. Proofs are stored as private bytes rather than at a public URL, because a transfer screenshot shows account numbers — holding a link to the collab is not enough to see one.",
  },
  {
    question: "Can I use it to book other creators?",
    answer:
      "Yes. One account covers your own creator page and sending offers to other creators, and the flow is identical in both directions.",
  },
  {
    question: "Does it work for barter deals?",
    answer:
      "Yes. An offer can be barter instead of a fee, with the deliverables and deadline written down exactly the same way — there is simply no payment schedule attached to it.",
  },
  {
    question: "What does a Serious or Priority offer change?",
    answer: `Where the offer lands, nothing about the terms — and you are never the one charged for it. Any offer is free to send, and a Basic one waits quietly in your standard inbox. A collaborator who wants to be seen sooner can pay a flat ${formatINR(OFFER_BOOST_TOTAL_PAISE.serious)} including GST to sort above Basic, open the thread with their brief and notify you on WhatsApp, or ${formatINR(OFFER_BOOST_TOTAL_PAISE.priority)} including GST to sort above both, unlock the call option for that collab and see when you have read a message. It comes out of their pocket and it is a flat fee, not a percentage of your collab.`,
  },
  {
    question: "Can we talk on a call?",
    answer:
      "On a Priority collab, yes. The collaborator requests a call, you approve, and only you start it. The platform rings both phones and bridges them, so neither number is ever shown to the other side. There are fifteen minutes per collab, and the recording is posted back into the thread — so anything agreed out loud is still on the record. Basic and Serious collabs run in the chat only.",
  },
  {
    question: "What does it cost?",
    answer:
      "Sending a Basic offer is free, and the platform never takes a cut of what you are paid. The only charges today are the optional Serious and Priority fees a collaborator pays to reach the top of your inbox. Platform pricing may later add a subscription for the tool.",
  },
  {
    question: "Are Serious or Priority fees refundable?",
    answer:
      "No. Those are optional platform fees for inbox placement and related features — not a deposit on the collab. They are non-refundable if the creator never replies, the deal falls through, or you change your mind. Purchases billed through the App Store or Google Play may also be subject to that store’s own refund rules.",
  },
] as const;
